import { DEFAULT_LANG } from "../types";

export const getDefLang = (e) => async (dispatch) => {
  dispatch({
    type: DEFAULT_LANG,
    payload: e,
  });
};
